import React from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useAuth } from '../context/AuthContext'

const Shell = styled.div`
  min-height: 100vh;
  background: radial-gradient(circle at top left, #eef7f1, #f8fafc 35%, #fefce8 100%);
  color: #111827;
  font-family: 'Lato', sans-serif;
`

const TopBar = styled.header`
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background: rgba(17, 24, 39, 0.95);
  color: #f9fafb;
  padding: 0.9rem 1.25rem;
  backdrop-filter: blur(6px);
`

const Brand = styled.div`
  h1 {
    margin: 0;
    font-size: 1.1rem;
    letter-spacing: 0.03em;
    font-family: 'Playfair Display', serif;
  }

  p {
    margin: 0.2rem 0 0;
    font-size: 0.85rem;
    color: #d1d5db;
  }
`

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`

const GhostLink = styled(Link)`
  color: #d1fae5;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.9rem;
`

const LogoutButton = styled.button`
  border: none;
  background: #ef4444;
  color: #fff;
  border-radius: 999px;
  padding: 0.45rem 0.9rem;
  cursor: pointer;
  font-weight: 700;
`

const Body = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.2rem;
`

const Tabs = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-bottom: 1rem;
`

const Tab = styled(NavLink)`
  padding: 0.55rem 0.9rem;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  text-decoration: none;
  color: #111827;
  font-weight: 700;
  font-size: 0.88rem;

  &:hover {
    background: #111827;
    color: #fff;
    border-color: #111827;
  }

  &.active {
    background: #111827;
    color: #fff;
    border-color: #111827;
  }
`

function AdminShell({ children }) {
  const navigate = useNavigate()
  const { user, logout } = useAuth()

  const handleLogout = async () => {
    await logout()
    navigate('/admin/login', { replace: true })
  }

  return (
    <Shell>
      <TopBar>
        <Brand>
          <h1>Sunbold Admin</h1>
          <p>{user ? `${user.username} (${user.role})` : 'Session'}</p>
        </Brand>

        <Right>
          <GhostLink to="/">Open Website</GhostLink>
          <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
        </Right>
      </TopBar>

      <Body>
        <Tabs>
          <Tab to="/admin/gallery">Gallery</Tab>
          <Tab to="/admin/projects">Projects</Tab>
          <Tab to="/admin/users">Users</Tab>
        </Tabs>

        {children}
      </Body>
    </Shell>
  )
}

export default AdminShell
